import { Button, Drawer, Form, Input, Switch, Tabs } from "antd";
import type { FormInstance } from "antd";
import ReactMarkdown from "react-markdown";

import type { AgentSkill } from "@fitness-app/data-models";

import { createSlug, type SkillFormValues } from "./constants";

type SkillEditorDrawerProps = {
  activeSkill: AgentSkill | null;
  contentLabel?: string;
  editTitle?: string;
  form: FormInstance<SkillFormValues>;
  markdownValue?: string;
  newTitle?: string;
  onClose: () => void;
  onSubmit: (values: SkillFormValues) => void;
  open: boolean;
  saving: boolean;
};

export const SkillEditorDrawer = ({
  activeSkill,
  contentLabel = "Treść skilla",
  editTitle = "Edytuj skill",
  form,
  markdownValue,
  newTitle = "Nowy skill",
  onClose,
  onSubmit,
  open,
  saving,
}: SkillEditorDrawerProps) => (
  <Drawer
    title={activeSkill ? editTitle : newTitle}
    open={open}
    onClose={onClose}
    width={760}
    extra={
      <Button type="primary" loading={saving} onClick={() => form.submit()}>
        Zapisz
      </Button>
    }
  >
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2">
        <Form.Item name="name" label="Nazwa" rules={[{ required: true }]}>
          <Input
            onBlur={(event) => {
              if (!form.getFieldValue("slug")) {
                form.setFieldValue("slug", createSlug(event.target.value));
              }
            }}
          />
        </Form.Item>
        <Form.Item name="slug" label="Slug" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="sortOrder" label="Kolejność">
          <Input type="number" />
        </Form.Item>
        <Form.Item name="enabled" label="Aktywny" valuePropName="checked">
          <Switch />
        </Form.Item>
      </div>
      <Form.Item name="description" label="Opis">
        <Input.TextArea rows={2} />
      </Form.Item>
      <Tabs
        items={[
          {
            key: "editor",
            label: "Markdown",
            children: (
              <Form.Item name="content" label={contentLabel} rules={[{ required: true }]}>
                <Input.TextArea rows={18} className="font-mono" />
              </Form.Item>
            ),
          },
          {
            key: "preview",
            label: "Podgląd",
            children: (
              <div className="prose max-w-none rounded-lg border border-gray-200 bg-white p-4">
                <ReactMarkdown>{markdownValue || ""}</ReactMarkdown>
              </div>
            ),
          },
        ]}
      />
    </Form>
  </Drawer>
);
